export default "/images/935de1b12514605a2dd8fd2e26287422.avif";